
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#252626","d":"M16.858 14.358a.5.5 0 01-.85-.36v-1h-1.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1.5v-1a.5.5 0 01.85-.35l3 2a.51.51 0 010 .71l-3 2zM21 1.001a2 2 0 011.995 1.85l.006.149L23 21a2 2 0 01-2 2H3a2 2 0 01-2-2V3.007a2 2 0 012-2L21 1zM20.999 3H3v18h17.999V3zm-8.504 11a.5.5 0 01.5.5v1.502h1.002a.5.5 0 01.36.851l-2.002 3.003a.51.51 0 01-.71 0l-2.002-3.003a.5.5 0 01.35-.851h1.001v-1.501a.5.5 0 01.5-.501zM7.154 9.645a.5.5 0 01.85.349v.999h1.5a.5.5 0 01.5.5v.998a.5.5 0 01-.5.5h-1.5v.998a.5.5 0 01-.86.36l-3-1.998a.508.508 0 010-.709zm5.196-5.501l1.997 3a.5.5 0 01-.36.86h-.998v1.5a.5.5 0 01-.5.5h-.999a.5.5 0 01-.5-.5v-1.5h-.997a.499.499 0 01-.35-.85l1.997-3.01a.51.51 0 01.71 0z","fill-rule":"evenodd"}})])
          )
        }
      }
    